import { Attachment } from '@/checkout-instore-legacy/product/typings'
import { createContext, useContext } from 'react'

export type ItemWithAttachements = {
  id: string
  quantity?: number
  manualPrice?: number | null
  attachments?: {
    name: string
    content: Record<string, string>
  }[]
}

export interface SetAttachmentsStateProps {
  attachments?: Attachment[]
  skuId?: string
  manualPrice?: number | null
  quantity?: number
  customOnSubmit?: (item: ItemWithAttachements) => void
  beforeAddToCart?: () => void
}

export interface AttachmentsContextType {
  showAttachments: boolean
  attachments?: Attachment[]
  skuId?: string
  manualPrice?: number | null
  quantity?: number
  customOnSubmit?: (item: ItemWithAttachements) => void
  beforeAddToCart?: () => void
  setAttachmentState: ({
    attachments,
    skuId,
    manualPrice,
    quantity,
    customOnSubmit,
    beforeAddToCart,
  }: SetAttachmentsStateProps) => void
  setShowAttachments: (open: boolean) => void
}

export const initialState: AttachmentsContextType = {
  showAttachments: false,
  setAttachmentState: () => {},
  setShowAttachments: () => {},
}

export const AttachmentsContext = createContext<AttachmentsContextType>(
  initialState
)

export function useAttachmentsContext() {
  return useContext(AttachmentsContext)
}
